/**
 * Iter 427.p40 — Portal route-guard.
 *
 * Second layer of the POPIA-safe portal gating. Even if a portal user
 * pastes /portal/documents directly into the address bar bypassing
 * the nav filter, this guard redirects them to /portal (Overview) and
 * shows a toast so they know why. The FIRST layer is the NAV filter
 * in PortalLayout; the THIRD is the per-endpoint `assert_portal_perm`
 * on the backend (which returns 403 with a code).
 */
import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { usePortalPerms } from "../../context/PortalPermsContext";
import { toast } from "../ui/sonner";

export default function PortalRouteGuard({ perm, children, redirectTo = "/portal" }) {
  const { can, loading } = usePortalPerms();
  const allowed = perm ? can(perm) : true;

  useEffect(() => {
    if (!loading && !allowed) {
      toast.error("Your portal user doesn't have access to this section.");
    }
  }, [loading, allowed]);

  if (loading) {
    // Render nothing while perms are still loading so we never
    // briefly show a page the user isn't allowed to see.
    return (
      <div
        className="text-xs text-[#647087] py-8 text-center"
        data-testid="portal-route-guard-loading"
      >
        Checking access…
      </div>
    );
  }
  if (!allowed) {
    return <Navigate to={redirectTo} replace />;
  }
  return children;
}
